/**
 * Get the Laravel user CSRF token from the DOM
 * @returns {string|null}   the CSRF token or null
 */
export function getLaravelCSRFToken() {
    const csrfTokenElem = document.querySelector('meta[name="csrf-token"]');
    if (!csrfTokenElem) {
        return null;
    }
    const token = csrfTokenElem.getAttribute('content');
    if (!token) {
        return null;
    }

    return token;
}

/**
 * Helper function to get the ID of the current visor/viewer
 * @returns {string}    the ULID of the visor/viewer
 */
export function getVisorID() {
    const container = window.getViewerContainer();
    let ulid = !container ? null : container.getAttribute('data-viewer-id');

    if (!ulid) {
        // Fallback, try to get the ULID from the URL
        // Example: http://example.com/map/01kak9f49hcd7dmjth8k06x55s
        const url = new URL(window.location.href);
        const pathname = url.pathname;
        const matches = pathname.match(/^\/map\/([0-9a-fA-F]{25})$/);
        if (matches) {
            ulid = matches[1];
        }
    }

    return ulid;
}

/**
 * Helper function to get the ID of the current project
 * @returns {number}    the ID of the project
 */
export function getProjectID() {
    const container = window.getMainAppContainer();
    return !container ? null : parseInt(container.getAttribute('data-project-id'));
}

/**
 * Helper function to get the svg icon 
 * @param {string} iconPath 
 * @param {string} fill 
 * @returns 
 */
export function getSvg(iconPath, fill = "currentColor") {

    // No path provided
    if (!iconPath) {
        return `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="${fill}" viewBox="0 0 16 16"><path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6"/></svg>`;
    }

    // Has svg tag?
    if (iconPath.includes('<svg')) {
        return iconPath;
    }

    // Has path tag?
    if (iconPath.includes('<path')) {
        return `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="${fill}" viewBox="0 0 16 16">${iconPath}</svg>`;
    }

    // Has no path neither svg tag
    if (iconPath) {
        return `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="${fill}" viewBox="0 0 16 16">
            <path d="${iconPath}"/>
        </svg>`;
    }

    return null;
}

/**
 * Check if a URL belongs to the same domain
 * 
 * @param {string} url
 * @returns {boolean}
 */
export function isAppDomain(url) {
    try {
        const urlObj = new URL(url, window.location.origin);
        return urlObj.origin === window.location.origin;
    } catch (e) {
        return false;
    }
}